module.exports = __webpack_public_path__ + "img/shot_tx20030501.e15dd93e.jpg";